import React, {useState} from 'react';
import useLoginModel from '@Modules/auth/components/LoginHooks/useLoginModel';
import {useAuth} from '@Services/AuthService/useAuth';

const LoginComponent = () => {
	const [credentials, setCredentials] = useState({email: '', password: ''});
	const [typePassword, setTypePassword] = useState('password');
	const { login } = useAuth();
	
	const {
		loginRequest,
		loadData,
		clearError,
		checkErrorClass,
		getErrors,
		getError,
	} = useLoginModel();
	
	const toggleShowPassword = () => {
		setTypePassword(typePassword === 'password' ? 'text' : 'password' );
	};
	
	const handleChangeInput = (event, name) => {
		setCredentials(prevState => ({...prevState, [name]: event.target.value}));
		clearError(name);
	};
	
	const onLogin = () => {
		loginRequest(credentials, login);
	};
	
	const keyDownHandler = event => {
		if (event.key === 'Enter') {
			onLogin()
			return;
		}
		
		return false;
	};
	
	return (
		<div className="auth">
			<div className="flex--row_center-between paddings--all_25">
				<div className="logo logo--white"></div>
			</div>
			
			<div className="auth__block">
				<div className="auth-form width--px_480">
					<div className="color--white font--32 text--center margin--bottom_30">
						Login
					</div>
					
					<div className="label margin--bottom_30">
						<div className="input-field input-field--dark">
							<input
								name={'email_name'}
								onChange={(event) => {handleChangeInput(event, 'email')}}
								type="email"
								value={credentials.email}
								className={checkErrorClass('email', 'input')}
								onKeyDown={keyDownHandler}/>
							<label htmlFor="email_name" className={credentials.email.length ? 'active' : ''}>E-mail</label>
							{getErrors('email')}
						</div>
					</div>
					
					<div className="label margin--bottom_30">
						<div className="input-field input-field--dark">
							<input
								name={'pass_name'}
								onChange={(event) => {handleChangeInput(event, 'password')}}
								type={ typePassword }
								value={credentials.password}
								className={`input-icon ${checkErrorClass('password', 'input')}`}
								onKeyDown={keyDownHandler}/>
							<label htmlFor="pass_name" className={credentials.password.length ? 'active' : ''}>Password</label>
							{getErrors('password')}
						</div>
						
						<div
							onClick={ toggleShowPassword }
							className={`${typePassword === 'text' ? 'hide-eye' : 'eye'}`}
						/>
					</div>
					
					<button onClick={onLogin} className={`button button--colored ${loadData ? 'button--green' : 'button--no-active'} width--px_280 margin--auto margin--bottom_20`}>
						Login
					</button>
					
					{getError('errorLogin') ?
						<div className="color--error margin--bottom_20 font--14 text--center">
							Invalid login or password
						</div>
						: ''
					}
				</div>
			</div>
		</div>
	);
};

export default LoginComponent;